<template>
	<span class="ui-toggle-switch">
		<input
            :id="id"
            :name="name"
            :checked="value"
            class="ios-toggle"
            type="checkbox"
            @click="onClick($event)"
            v-bind="$attrs"
        >
		<label :for="id" class="ios-checkbox-label"></label>
	</span>
</template>
<script>
    export default {
        inheritAttrs: false,
        props: ['value', 'id', 'name', 'areYouSure', 'dataCy'],

        data: () => { return {

        }},

        methods: {
            onClick: function ($event) {

                this.$emit('click', $event);

                if (this.areYouSure && this.areYouSure.value) {

                    let confirmation = false;

                    confirmation = confirm(this.areYouSure.text);

                    if (!confirmation) {

                        $event.target.checked = !$event.target.checked;
                        return false;
                    }
                }

                this.$emit('input', $event.target.checked);
            },
        }

    }
</script>
